import { FirebaseOptions, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyA1VSZ9tLpBjJJdT18uPB4gliTcQDr19W0",
  authDomain: "thedailydo-61fcc.firebaseapp.com",
  projectId: "thedailydo-61fcc",
  storageBucket: "thedailydo-61fcc.firebasestorage.app",
  messagingSenderId: "1040891411508",
  appId: "1:1040891411508:web:2dfb91f76d681451d85e61",
  measurementId: "G-FTH2VCZ9MD",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Initialize Analytics only in browser environment
const analyticsPromise = isSupported().then(supported =>
  supported ? getAnalytics(app) : null
);

export { auth, db, storage, analyticsPromise };